import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  Box,
  Stack,
  Grid,
  Typography,
  IconButton,
} from "@mui/material";
import { sendOrder } from "../sendOrder";
import SendIcon from "@mui/icons-material/Send";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import InputText from "../Fields/InputText";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import {
  formatNumber,
  roundTotalMonthlyFeeByCountry,
} from "../../logic/GeneralFunctions";
const contractType = { leaseplus: "Lease Plus" };

export default class DisplayContract extends React.Component {
  static propTypes = {
    creditFile: PropTypes.object,
    contractFile: PropTypes.object,
    labels: PropTypes.object,
    params: PropTypes.object,
    switchFormState: PropTypes.func,
    formInformation: PropTypes.object,
    productsValues: PropTypes.object,
    customerInformation: PropTypes.object,
    accessories: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    extraFiles: PropTypes.array,
    products: PropTypes.array,
    variables: PropTypes.object,
    newDealerInformation: PropTypes.object,
    creditError: PropTypes.bool,
    sendContract: PropTypes.func,
    createTransferAgreementPdf: PropTypes.func,
    changeHandler: PropTypes.func,
    invoiceDidNotMatch: PropTypes.bool,
  };

  state = {
    submited: false,
    ownCopy: true,
    sentForSigning: false,
    signingError: false,
    showSummary: false,
    showSigningInfoDialog: false,
    printFrameLoaded: false,
    printPreviewOpen: false,
  };

  printFrameRef = React.createRef();

  switchFormState = (value) => {
    this.props.switchFormState(value);
  };

  handleChecked = () => {
    this.setState({ ownCopy: !this.state.ownCopy });
  };

  toggleSummary = () => {
    this.setState({ showSummary: !this.state.showSummary });
  };

  handlePrint = () => {
    const printFrame = this.printFrameRef.current;

    if (!printFrame || !printFrame.contentWindow) {
      return;
    }

    try {
      printFrame.contentWindow.focus();
      printFrame.contentWindow.print();
    } catch (error) {
      this.openPdfInNewTab();
    }
  };

  openPrintPreview = () => {
    this.setState({ printPreviewOpen: true });
  };

  closePrintPreview = () => {
    this.setState({ printPreviewOpen: false });
  };

  openPdfInNewTab = () => {
    if (!this.props.contractFile.fileDisplay) {
      return;
    }

    window.open(
      this.props.contractFile.fileDisplay,
      "_blank",
      "noopener,noreferrer",
    );
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.contractFile.fileDisplay !== this.props.contractFile.fileDisplay
    ) {
      this.setState({ printFrameLoaded: false });
    }
  }

  toggleSigningInfoDialog = () => {
    this.setState({ showSigningInfoDialog: !this.state.showSigningInfoDialog });
  };

  handleSigningInfoConfirm = () => {
    this.setState({ showSigningInfoDialog: false, showSummary: true });
  };
  serverResponce = async (res) => {
    const lang = this.props.params.lang.toLowerCase();
    if (res.status === 200) {
      // if the mail was successfuly sent
      if (lang === "fr" || lang === "de" || lang === "uk") {
        try {
          await this.props.createTransferAgreementPdf();
          this.switchFormState("transfer_agreement");
        } catch (err) {
          console.log(err);
          this.switchFormState("completed");
        }
      } else {
        this.switchFormState("completed");
      }
    } else {
      //if not
      console.log(res.err);
    }
  };

  handleChange = (value, id) => {
    let newState = this.state;
    let data = {};
    data[id] = value;
    this.props.changeHandler(data);
    this.setState(newState);
  };

  signingText = {
    fr: {
      header: "Le contrat a maintenant été envoyé au client !",
      body: "Veuillez NE PAS fermer le portail ni actualiser la page. Afin que la commande soit envoyée à HCS, vous devez compléter toutes les étapes dans le portail.",
      button: "J'ai bien compris",
    },
    de: {
      header: "Der Vertrag wurde nun an den Kunden gesendet!",
      body: "Bitte schließen Sie das Portal NICHT und aktualisieren Sie die Seite nicht. Damit die Bestellung an HCS gesendet werden kann, müssen Sie alle Schritte im Portal abschließen.",
      button: "Ich habe verstanden",
    },
    uk: {
      header: "The contract has now been sent to the customer!",
      body: "Please DO NOT close the portal or refresh the page. In order for the order to be sent to HCS, you need to complete all steps in the portal.",
      button: "I understand",
    },
  };
  render() {
    const lang = this.props.params.lang.toLowerCase();
    const formType = this.props.params.formType.toLowerCase();
    const signingText = this.signingText[lang] || {};
    return (
      <div>
        <Modal
          open={this.state.showSigningInfoDialog}
          onClose={this.toggleSigningInfoDialog}
          aria-labelledby="signing-modal-title"
          aria-describedby="signing-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "35%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "500px",
              bgcolor: "background.paper",
              border: "2px solid #273A60",
              boxShadow: 24,
              borderRadius: 2,
              p: 3,
              textAlign: "center",
            }}
          >
            <WarningAmberRoundedIcon
              sx={{ fontSize: 56, color: "#f59e0b", mb: 1 }}
            />
            <Typography
              id="signing-modal-title"
              variant="h6"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#273A60" }}
            >
              {signingText.header || ""}
            </Typography>

            <Typography
              id="signing-modal-description"
              variant="body1"
              sx={{ mt: 1, mb: 4, lineHeight: 1.6 }}
            >
              {signingText.body || ""}
            </Typography>

            <Button
              variant="contained"
              size="medium"
              sx={{ backgroundColor: "#273A60", px: 4, mb: 2 }}
              onClick={this.handleSigningInfoConfirm}
            >
              {signingText.button || ""}
            </Button>
          </Box>
        </Modal>

        <Modal
          open={this.state.showSummary}
          onClose={this.toggleSummary}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "50%",
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              borderRadius: 2,
              p: 4,
              textAlign: "center",
            }}
          >
            <Typography variant="h4" gutterBottom>
              <strong>{this.props.labels.summery_title}</strong>
            </Typography>
            <Box component="section" sx={{ p: 2, border: "2px solid black" }}>
              <Stack spacing={2} style={{ alignItems: "start" }}>
                <Typography gutterBottom>
                  <strong>{this.props.labels.customer}:</strong>{" "}
                  {this.props.customerInformation.customerFirstName +
                    " " +
                    this.props.customerInformation.customerLastName}
                </Typography>
                <Typography gutterBottom>
                  <strong>{this.props.labels.label_email}:</strong>{" "}
                  {this.props.customerInformation.customerEmail}
                </Typography>
                <Typography gutterBottom>
                  <strong>{this.props.labels.agreement}:</strong>{" "}
                  {contractType[this.props.params.formType.toLowerCase()]}
                </Typography>
                <Typography gutterBottom>
                  <strong>{this.props.labels.monthly_cost}:</strong>{" "}
                  {formatNumber(
                    roundTotalMonthlyFeeByCountry(
                      lang,
                      this.props.formInformation.totalMonthlyFee,
                    ),
                    lang,
                    formType,
                  ) +
                    " " +
                    this.props.labels.currency +
                    " " +
                    this.props.labels.inc_vat}
                </Typography>
                <Typography gutterBottom>
                  <strong>{this.props.labels.contract_length}:</strong>{" "}
                  {this.props.formInformation.contractLength +
                    " " +
                    this.props.labels.months}
                </Typography>
                <div style={{ display: "flex", alignItems: "start" }}>
                  <Typography gutterBottom>
                    <strong>{this.props.labels.products}:</strong>{" "}
                  </Typography>

                  <Stack
                    direction="column"
                    style={{ marginLeft: "8px", alignItems: "flex-start" }}
                  >
                    {Object.values(this.props.productsValues).map(
                      (product, index) => (
                        <Typography key={index} component="div">
                          {product.quantity}x {product.name}
                        </Typography>
                      ),
                    )}
                  </Stack>
                </div>
                <div style={{ display: "flex", alignItems: "start" }}>
                  <Typography gutterBottom>
                    <strong>{this.props.labels.accessory}:</strong>{" "}
                  </Typography>

                  <Stack
                    direction="column"
                    style={{ marginLeft: "8px", alignItems: "flex-start" }}
                  >
                    {Object.values(this.props.productsValues).map(
                      (product, index) => (
                        <Typography key={index} component="div">
                          {product.accessory}
                        </Typography>
                      ),
                    )}
                  </Stack>
                </div>
                <Typography gutterBottom>
                  <strong>{this.props.labels.dealer}:</strong>{" "}
                  {this.props.customerInformation.dealerName}
                </Typography>
              </Stack>
            </Box>

            <Stack direction="column" alignItems="center" spacing={2}>
              <Typography variant="h6" gutterBottom>
                <strong>{this.props.labels.final_check}</strong>
              </Typography>
              {!this.state.submited ? (
                <Stack direction="row" spacing={2} alignItems="center">
                  <Button
                    variant="contained"
                    size="large"
                    sx={{ mt: 2, backgroundColor: "#273A60" }}
                    onClick={async () => {
                      this.setState({ submited: true });
                      // handling different since if fr and not direct debit then manual handling
                      if (
                        (lang === "fr" || lang === "de" || lang === "uk") &&
                        !this.props.formInformation.directDebit
                      ) {
                        let data = { ...this.props };
                        data["apiError"] = "OBS!! Ej direkt debit";
                        await sendOrder(
                          data,
                          this.state.ownCopy,
                          this.serverResponce,
                        );
                      } else if (
                        (lang === "fr" || lang === "de" || lang === "uk") &&
                        this.props.invoiceDidNotMatch
                      ) {
                        let data = { ...this.props };
                        data["apiError"] = "OBS!! Faktura matchar inte";
                        await sendOrder(
                          data,
                          this.state.ownCopy,
                          this.serverResponce,
                        );
                      } else {
                        const signing = await this.props.sendContract();

                        //check if verified is possible to send
                        if (signing?.error) {
                          alert(this.props.labels.contract_signing_error);
                          this.setState({
                            signingError: true,
                            submited: false,
                          });
                        }
                        //Verified was succesfully sent, send copy to HCS
                        else {
                          let data = { ...this.props };
                          data["apiError"] = "";
                          if (lang !== "fr" && lang !== "de" && lang !== "uk") {
                            await sendOrder(
                              data,
                              this.state.ownCopy,
                              this.serverResponce,
                            );
                          } else {
                            this.serverResponce({ status: 200 });
                          }
                        }
                      }
                    }}
                  >
                    {this.props.labels.positive_answer}
                  </Button>
                  <Button
                    variant="contained"
                    size="large"
                    sx={{ mt: 2, backgroundColor: "#273A60" }}
                    onClick={() => {
                      this.setState({ modalOpen: false });
                      this.switchFormState("edit");
                    }}
                  >
                    {this.props.labels.negative_answer}
                  </Button>
                </Stack>
              ) : (
                <Box sx={{ textAlign: "right" }}>
                  <CircularProgress />
                </Box>
              )}
            </Stack>
          </Box>
        </Modal>

        <div className="margin-bot">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {this.props.labels.customer_information_title}{" "}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <InputText
                id="customerEmail"
                label={this.props.labels.label_email}
                defaultValue={this.props.customerInformation.customerEmail}
                changeHandler={this.handleChange}
                sx={{ width: "100%" }}
                required={true}
                className={
                  this.props.formInformation.showInvalid &&
                  !this.state.customerEmail
                    ? "invalid"
                    : ""
                }
              />
            </Grid>
          </Grid>
        </div>
        <div>
          {this.props.contractFile.fileDisplay ? (
            <div style={{ textAlign: "center" }}>
              <object
                data={
                  this.props.contractFile.fileDisplay +
                  "#toolbar=0&navpanes=0&scrollbar=0&amp;page=3&amp;view=FitV"
                }
                width="76%"
                height="1000px"
              >
                <p>
                  Your browser does not support PDFs. Please download the PDF to
                  view it:
                  <a href={this.props.contractFile.fileDisplay}>Download PDF</a>
                  .
                </p>
              </object>
              <iframe
                ref={this.printFrameRef}
                title="Contract print frame"
                src={this.props.contractFile.fileDisplay}
                onLoad={() => this.setState({ printFrameLoaded: true })}
                style={{
                  border: 0,
                  height: 0,
                  opacity: 0,
                  pointerEvents: "none",
                  position: "fixed",
                  right: 0,
                  top: 0,
                  width: 0,
                }}
              />
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
              <p>{"Creating contract PDF..."}</p>
            </div>
          )}
          <Button
            sx={{
              backgroundColor: "#273A60",
              marginLeft: "10px",
            }}
            onClick={this.openPrintPreview}
            variant="contained"
            disabled={!this.props.contractFile.fileDisplay}
          >
            <PrintRoundedIcon sx={{ marginRight: "5px" }} />
            {this.props.labels.print || "Print"}
          </Button>
          <div>
            <FormControlLabel
              className="checkbox"
              control={
                <Checkbox
                  id="quote_check"
                  checked={this.state.ownCopy}
                  onChange={this.handleChecked}
                />
              }
              label={this.props.labels.copy}
            />
          </div>
          {this.state.signingError && (
            <div className="rightButton">
              {!this.state.submited ? (
                <Button
                  sx={{
                    minWidth: "350px",
                    minHeight: "45px",
                    backgroundColor: "#273A60",
                    marginRight: "-8px",
                  }}
                  onClick={async () => {
                    this.setState({ submited: true });
                    let data = { ...this.props };
                    data["apiError"] =
                      "OBS!! Kontraktet kunde inte skickas till Verified för signering.";
                    await sendOrder(
                      data,
                      this.state.ownCopy,
                      this.serverResponce,
                    );
                  }}
                  variant="contained"
                >
                  {this.props.labels.submit}{" "}
                  <SendIcon sx={{ marginLeft: "15px" }} />
                </Button>
              ) : (
                <Box>
                  <CircularProgress />
                </Box>
              )}
            </div>
          )}
          <div className="button-container">
            <div className="button-container-row">
              <Button
                sx={{ backgroundColor: "#273A60" }}
                onClick={() => {
                  this.switchFormState("edit");
                }}
                variant="contained"
              >
                <ArrowBackRoundedIcon sx={{ marginRight: "5px" }} />
                {this.props.labels.edit_form}
              </Button>

              <Button
                sx={{
                  minWidth: "350px",
                  minHeight: "45px",
                  backgroundColor: "#273A60",
                }}
                onClick={
                  lang === "fr" || lang === "de" || lang === "uk"
                    ? this.toggleSigningInfoDialog
                    : this.toggleSummary
                }
                variant="contained"
                disabled={this.props.contractFile.fileDisplay ? false : true}
              >
                {this.props.labels.send_for_signing}{" "}
                <SendIcon sx={{ marginLeft: "15px" }} />
              </Button>
            </div>
          </div>
          <Dialog
            open={this.state.printPreviewOpen}
            onClose={this.closePrintPreview}
            fullWidth
            maxWidth="lg"
          >
            <DialogTitle sx={{ paddingRight: "48px" }}>
              {this.props.labels.print_preview || "Print preview"}
              <IconButton
                aria-label="Close print preview"
                onClick={this.closePrintPreview}
                sx={{ position: "absolute", right: 8, top: 8 }}
              >
                <CloseRoundedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ height: "80vh", padding: 0 }}>
              {this.props.contractFile.fileDisplay && (
                <object
                  data={
                    this.props.contractFile.fileDisplay +
                    "#toolbar=1&navpanes=0&scrollbar=1&amp;view=FitH"
                  }
                  type="application/pdf"
                  width="100%"
                  height="100%"
                >
                  <p style={{ padding: "16px" }}>
                    Your browser does not support PDFs. Please download the PDF
                    to view it:
                    <a href={this.props.contractFile.fileDisplay}>
                      Download PDF
                    </a>
                    .
                  </p>
                </object>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.openPdfInNewTab}>
                <OpenInNewRoundedIcon sx={{ marginRight: "5px" }} />
                {this.props.labels.open_pdf || "Open PDF"}
              </Button>
              <Button
                onClick={this.handlePrint}
                variant="contained"
                disabled={!this.state.printFrameLoaded}
                sx={{ backgroundColor: "#273A60" }}
              >
                <PrintRoundedIcon sx={{ marginRight: "5px" }} />
                {this.props.labels.print || "Print"}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}
